import { createLoadingAction, createRunMutationAction } from '@/store/utils';
import * as types from '@/store/spCompanyRegistration/actionTypes';
import * as mutationTypes from '@/store/spCompanyRegistration/mutationTypes';
// eslint-disable-next-line import/no-cycle
import {
  loadCertificatesForCompanySP, loadRegionsForSP,
  loadEmployeesAmountForSP, loadCompanySuggest, loadServicesForCompanySP, registerSPCompany,
} from '@/services/repository';

export default {
  [types.CHANGE_SP_COMPANY_MAIN_INFO]: createRunMutationAction(mutationTypes.SET_SP_COMPANY_MAIN_INFO),
  [types.CHANGE_SP_COMPANY_RECOMMENDATION_INFO]: createRunMutationAction(mutationTypes.SET_SP_COMPANY_RECOMMENDATION_INFO),
  [types.CHANGE_SP_COMPANY_SOCIAL_NETWORK_LINK_INFO]: createRunMutationAction(mutationTypes.SET_SP_COMPANY_SOCIAL_NETWORK_LINK_INFO),
  [types.CHANGE_SP_COMPANY_IP_ADDRESS_INFO]: createRunMutationAction(mutationTypes.SET_SP_COMPANY_IP_ADDRESS_INFO),
  [types.CHANGE_SP_COMPANY_CERTIFICATIONS_INFO]: createRunMutationAction(mutationTypes.SET_SP_COMPANY_CERTIFICATION_INFO),
  [types.CHANGE_SP_COMPANY_SERVICES_INFO]: createRunMutationAction(mutationTypes.SET_SP_COMPANY_SERVICES_INFO),
  [types.CHANGE_SP_COMPANY_AVATAR]: createRunMutationAction(mutationTypes.SET_SP_COMPANY_CLIENT_AVATAR),
  [types.CLEAN_SP_COMPANY_REGISTRATION_DATA]: createRunMutationAction(mutationTypes.REMOVE_SP_COMPANY_REGISTRATION_DATA),
  [types.CHANGE_SP_COMPANY_REGISTRATION_CURRENT_STEP]: createRunMutationAction(mutationTypes.SET_SP_COMPANY_REGISTRATION_CURRENT_STEP),
  [types.CHANGE_SP_COMPANY_EMAIL_VERIFICATION_INFO]: createRunMutationAction(mutationTypes.SET_SP_COMPANY_EMAIL_VERIFICATION_INFO),
  [types.CHANGE_SP_COMPANY_REGISTRATION_RECAPTCHA_TOKEN]: createRunMutationAction(mutationTypes.SET_SP_COMPANY_REGISTRATION_RECAPTCHA_TOKEN),
  [types.CHANGE_SP_COMPANY_REGISTRATION_FILLED_STEPS_COUNT]: createRunMutationAction(
    mutationTypes.SET_SP_COMPANY_REGISTRATION_FILLED_STEPS_COUNT,
  ),
  [types.CHANGE_SP_COMPANY_REGISTRATION_VISITED_STEPS_COUNT]: createRunMutationAction(
    mutationTypes.SET_SP_COMPANY_REGISTRATION_VISITED_STEPS_COUNT,
  ),
  [types.LOAD_COMPANY_SUGGESTIONS_FOR_SP]: createLoadingAction({
    method: loadCompanySuggest,
    dataKey: 'companySuggestionsForSP',
    settingDataMutation: mutationTypes.SET_COMPANY_SUGGESTIONS_FOR_SP,
    settingLoadingMutation: mutationTypes.SET_SP_COMPANY_SUGGEST_INFO_LOADING,
    settingErrorMutation: mutationTypes.SET_SP_COMPANY_SUGGEST_INFO_LOADING_ERRORS,
  }),
  [types.LOAD_SP_COMPANY_SERVICES]: createLoadingAction({
    method: loadServicesForCompanySP,
    dataKey: 'spCompanyServices',
    settingDataMutation: mutationTypes.SET_SERVICES_SP_COMPANY,
    settingLoadingMutation: mutationTypes.SET_SP_COMPANY_SERVICES_INFO_LOADING,
    settingErrorMutation: mutationTypes.SET_SP_COMPANY_SERVICES_INFO_LOADING_ERRORS,
  }),
  [types.LOAD_SP_COMPANY_CERTIFICATES]: createLoadingAction({
    method: loadCertificatesForCompanySP,
    dataKey: 'spCompanyCertificates',
    settingDataMutation: mutationTypes.SET_CERTIFICATES_SP_COMPANY,
    settingLoadingMutation: mutationTypes.SET_SP_COMPANY_CERTIFICATES_INFO_LOADING,
    settingErrorMutation: mutationTypes.SET_SP_COMPANY_CERTIFICATES_INFO_LOADING_ERRORS,
  }),
  [types.LOAD_SP_COMPANY_REGIONS]: createLoadingAction({
    method: loadRegionsForSP,
    dataKey: 'spCompanyRegions',
    settingDataMutation: mutationTypes.SET_REGIONS_SP_COMPANY,
    settingLoadingMutation: mutationTypes.SET_SP_COMPANY_REGIONS_INFO_LOADING,
    settingErrorMutation: mutationTypes.SET_SP_COMPANY_REGIONS_INFO_LOADING_ERRORS,
  }),
  [types.LOAD_SP_COMPANY_EMPLOYEES_AMOUNT]: createLoadingAction({
    method: loadEmployeesAmountForSP,
    dataKey: 'spCompanyAmountOfEmployees',
    settingDataMutation: mutationTypes.SET_EMPLOYEES_AMOUNT_SP_COMPANY,
    settingLoadingMutation: mutationTypes.SET_SP_COMPANY_EMPLOYEES_AMOUNT_INFO_LOADING,
    settingErrorMutation: mutationTypes.SET_SP_COMPANY_EMPLOYEES_AMOUNT_INFO_LOADING_ERRORS,
  }),
  async [types.REGISTER_SP_COMPANY]({ getters }) {
    const {
      workEmail,
      password,
      firstName,
      lastName,
      phoneNumber,
    } = getters.spCompanyRegistrationEmailVerificationInfo;
    const {
      yearsOfExperience,
      servicesChosen,
    } = getters.spCompanyServicesInfo;
    const {
      organizationDomain,
      organizationName,
      employeesNumber,
      officeLocation,
    } = getters.spCompanyRegistrationMainInfo;
    const userData = {
      mainInfo: {
        organizationDomain: organizationDomain?.toLowerCase().trim() || '',
        organizationName,
        employeesNumber,
        officeLocation,
      },
      emailVerificationInfo: {
        workEmail,
        password,
        firstName,
        lastName,
        phoneNumber,
      },
      servicesInfo: {
        yearsOfExperience,
        servicesChosen,
      },
      certificationInfo: {
        certificationData: getters.spCompanyRegistrationCompanyCertificationInfo,
        socialMediaLinks: getters.spCompanyRegistrationCompanySocialNetworkLinkInfo,
        ipAddress: getters.spCompanyRegistrationCompanyIpAddressInfo.ipAddress,
      },
      avatar: getters.spCompanyClientAvatar,
      recaptchaToken: getters.spCompanyRecaptchaToken,
    };
    const result = await registerSPCompany(userData);
    return result;
  },
};
